import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

/** Digits-only official code. Empty / omit means unset. */
export const OptionalOfficialDigitCodeSchema = z
  .string()
  .trim()
  .regex(/^\d*$/)
  .nullable()
  .optional();

export const GeoCityItemSchema = z.looseObject({
  id: z.uuid(),
  name: z.string(),
  stateId: z.uuid(),
  stateCode: z.string(),
  municipalCode: z.string().nullable(),
  ibgeCode: z.string().nullable(),
});

export type GeoCityItem = z.infer<typeof GeoCityItemSchema>;

export const GeoStateItemSchema = z.looseObject({
  id: z.uuid(),
  code: z.string(),
  name: z.string(),
});

export type GeoStateItem = z.infer<typeof GeoStateItemSchema>;

export const ListGeoStatesResponseSchema = z.looseObject({
  items: z.array(GeoStateItemSchema),
});

export type ListGeoStatesResponse = z.infer<typeof ListGeoStatesResponseSchema>;

export const ListGeoCitiesQuerySchema = PaginationSchema.extend({
  search: z.string().max(100).optional(),
  stateId: z.uuid().optional(),
});

export type ListGeoCitiesQuery = z.infer<typeof ListGeoCitiesQuerySchema>;

export const ListGeoCitiesResponseSchema = z.looseObject({
  items: z.array(GeoCityItemSchema),
  pagination: z.looseObject({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type ListGeoCitiesResponse = z.infer<typeof ListGeoCitiesResponseSchema>;

export const GeoCityParamsSchema = z.looseObject({
  cityId: z.uuid(),
});

export type GeoCityParams = z.infer<typeof GeoCityParamsSchema>;

export const GetGeoCityResponseSchema = z.looseObject({
  city: GeoCityItemSchema,
});

export type GetGeoCityResponse = z.infer<typeof GetGeoCityResponseSchema>;

export const CreateGeoCityBodySchema = z.looseObject({
  stateId: z.uuid(),
  name: z.string().trim().min(1).max(120),
  municipalCode: OptionalOfficialDigitCodeSchema,
  ibgeCode: OptionalOfficialDigitCodeSchema,
});

export type CreateGeoCityBody = z.infer<typeof CreateGeoCityBodySchema>;

export const UpdateGeoCityBodySchema = z.looseObject({
  name: z.string().trim().min(1).max(120).optional(),
  municipalCode: OptionalOfficialDigitCodeSchema,
  ibgeCode: OptionalOfficialDigitCodeSchema,
});

export type UpdateGeoCityBody = z.infer<typeof UpdateGeoCityBodySchema>;
